import { ENDPOINTS } from "@/api/application-api";
import { NodeOutput } from "@/components/Workflows/types";
import { useAuth } from "@/context/auth-context";
import { useUser } from "@/context/user-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { authHeader } from "@/utils/headers";
import { useQuery } from "@tanstack/react-query";

export const useOutputResult = (
  workflowVersionExecutionId: number | undefined,
  workflowNodeId: string | undefined,
) => {
  const { activeWorkspaceId: workspaceId } = useUser();
  const userToken = useAuth()?.userToken!;
  return useQuery<
    {
      [key: string]: NodeOutput;
    },
    Error
  >(
    [
      ENDPOINTS.workflow_version_execution_results(workspaceId!),
      workflowVersionExecutionId,
      workflowNodeId,
    ],
    async () => {
      if (!workflowVersionExecutionId || !workflowNodeId) {
        throw new Error("Required parameters missing");
      }
      const url = new URL(
        ENDPOINTS.workflow_version_execution_results(workspaceId!),
      );
      url.searchParams.set(
        "workflow_version_execution_id",
        String(workflowVersionExecutionId),
      );
      url.searchParams.set("workflow_node_id", String(workflowNodeId));
      url.searchParams.set("format", "2");

      const response = await fetch(url.toString(), {
        headers: authHeader(userToken),
      });

      return handleResponse(response);
    },
    {
      enabled: !!workflowVersionExecutionId && !!workflowNodeId,
      refetchOnWindowFocus: false,
    },
  );
};
